import Loader from 'components/atoms/loader';
import { RobotDashboardSummaryTypes } from 'interfaces/robot_dashboard';
import React, { useEffect, useState } from 'react';
import { fetchRobotDashboardSummary } from 'services/actions/robot_dashboard_actions';
import DataTable from 'react-data-table-component';
import { datatableColumns, datatableData } from './datatable_list';
import { Container } from './styles';

const RobotDashboardSummary = () => {
  const [robotSummary, setRobotSummary] = useState<RobotDashboardSummaryTypes | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    fetchRobotDashboardSummary(setRobotSummary, setLoading, setLoaded, setError);
  }, []);

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: '14px',
        fontWeight: 'bold',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (
    <Container className="container-fluid big-resolutions p-4">
      {loading && <Loader />}
      {error && <div>Erro ao Carregar Dados</div>}
      {loaded && (
        <>
          <div className="row">
            <div className="col">
              <div className="card rounded">
                <div className="card-body d-flex align-items-center p-3">
                  <div className="metric-icon mr-3 d-flex align-items-center justify-content-center">
                    <span className="material-icons">public</span>
                  </div>
                  <div className="metric-text">
                    <h4 className="mb-0">{robotSummary?.onlineClientsCount || 0}</h4>
                    <span>Usuários Online</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card rounded">
                <div className="card-body d-flex align-items-center p-3">
                  <div className="metric-icon mr-3 d-flex align-items-center justify-content-center">
                    <span className="material-icons">group</span>
                  </div>
                  <div className="metric-text">
                    <h4 className="mb-0">{robotSummary?.activeIdsCount || 0}</h4>
                    <span>IDs Ativos</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card rounded">
                <div className="card-body d-flex align-items-center p-3">
                  <div className="metric-icon mr-3 d-flex align-items-center justify-content-center">
                    <span className="material-icons">description</span>
                  </div>
                  <div className="metric-text">
                    <h4 className="mb-0">{robotSummary?.registeredAuctionsCount || 0}</h4>
                    <span>Cadastradas</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card rounded">
                <div className="card-body d-flex align-items-center p-3">
                  <div className="metric-icon mr-3 d-flex align-items-center justify-content-center">
                    <span className="material-icons">settings</span>
                  </div>
                  <div className="metric-text">
                    <h4 className="mb-0">{robotSummary?.configuredAuctionsCount || 0}</h4>
                    <span>Configuradas</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card rounded">
                <div className="card-body d-flex align-items-center p-3">
                  <div className="metric-icon mr-3 d-flex align-items-center justify-content-center">
                    <span className="material-icons">check_circle</span>
                  </div>
                  <div className="metric-text">
                    <h4 className="mb-0">{robotSummary?.doneAuctionsCount || 0}</h4>
                    <span>Disputadas</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <h4>Usuários online</h4>
              {robotSummary && (
                <DataTable
                  columns={datatableColumns()}
                  data={datatableData(robotSummary?.onlineClientsData)}
                  customStyles={customStyles}
                  noDataComponent={<div className="p-5">Nenhum usuário ativo no momento.</div>}
                />
              )}
            </div>
          </div>
        </>
      )}
    </Container>
  );
};

export default RobotDashboardSummary;
